import React from 'react'
import {
  BooleanField,
  Datagrid,
  TextField,
  TextInput,
  // SearchInput,
  SelectInput,
  useTranslate,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, ROLES_FIELDS } from '../../providers/localization/constant'

const RolesPermissionsListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${ROLES_FIELDS}.name`)}
    // />,
    <TextInput key={0} source='name' alwaysOn label={translate(`${ROLES_FIELDS}.name`)} />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.status.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
        { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
      ]}
    />,
  ]
}

const RolesPermissionsList = (): JSX.Element => {
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={RolesPermissionsListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='edit' bulkActionButtons={false}>
        <TextField source='name' label={`${ROLES_FIELDS}.name`}></TextField>
        <DateField
          source='create_at'
          showTime={true}
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          showTime={true}
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default RolesPermissionsList
